import Work1 from "../../assets/app-receitas.png";
import Work2 from "../../assets/caminhos.png";
import Work3 from "../../assets/gamestore.png";
import Work4 from "../../assets/maresias-atlantico.png";
import Work5 from "../../assets/sac.png";
import Work6 from "../../assets/starwars.png";
import Work7 from "../../assets/trivia.png";

export const projectsData = [
  {
    id: 1,
    image: Work7,
    title: "Trivia",
    category: "Fullstack",
    deploymentLink: "https://github.com/TiagoEmanuel8/Trivia",
  },
  {
    id: 2,
    image: Work1,
    title: "App de Receitas",
    category: "Backend",
    deploymentLink: "https://recipes-app-tiagoemanuel8.vercel.app/",
  },
  {
    id: 3,
    image: Work2,
    title: "Caminhos da Esperança",
    category: "Fullstack",
    deploymentLink: "https://caminho-de-esperanca.vercel.app/",
  },
  {
    id: 4,
    image: Work6,
    title: "Planetas Starwars",
    category: "Fullstack",
    deploymentLink: "https://github.com/TiagoEmanuel8/Starwars-Planets",
  },
  {
    id: 5,
    image: Work3,
    title: "Api Gamestore",
    category: "Backend",
    deploymentLink: "https://gamestore.up.railway.app/docs",
  },
  {
    id: 6,
    image: Work4,
    title: "Maresias do Atlântico",
    category: "Backend",
    deploymentLink: "https://github.com/TiagoEmanuel8/maresias-atlantico",
  },
  {
    id: 7,
    image: Work5,
    title: "Easy Sac",
    category: "Fullstack",
    deploymentLink: "https://easy-sac.vercel.app/",
  },
];

export const projectsNav = [
    {
        name: "all",
      },
  {
    name: "Fullstack",
  },
  {
    name: "Backend",
  },
];
